import { NoResultsPlaceholder, Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

import ChartEmptyStateImg from 'images/chart-empty-state.png'

const ChartEmptyState: FC = () => {
    return (
        <Box sx={{ height: `431px` }}>
            <NoResultsPlaceholder
                message={
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 3,
                            flexDirection: 'column',
                        }}
                    >
                        <img width={150} src={ChartEmptyStateImg} />
                        <Text
                            variant={`h6`}
                            sx={{
                                textAlign: 'center',
                                maxWidth: '250px',
                            }}
                        >
                            Not enough data (yet)
                        </Text>
                        <Text variant={'body3'} sx={{ textAlign: 'center', color: `Grey600` }}>
                            Data health needs a few more data points to take shape. <br />
                            Run additional calculations to bring this graph to life.
                        </Text>
                    </Box>
                }
            />
        </Box>
    )
}

export default ChartEmptyState
